import { toLatLon } from 'utm';
import RegexBuilder from './RegexBuilder';
const parsers = [
    {
        regex: new RegexBuilder().plusMinus().decimalNumber().comma().plusMinus().decimalNumber().build(),
        parser: fromDecimalDegrees,
    },
    {
        regex: new RegexBuilder().decimalNumber().degreeOption().ns().comma().decimalNumber().degreeOption().ew().build(),
        parser: fromDecimalDegreesNSEW,
    },
    {
        regex: new RegexBuilder().decimalNumber().whiteSpace().ns().comma().decimalNumber().whiteSpace().ew().build(),
        parser: fromDecimalDegreesNSEW,
    },
    {
        regex: new RegexBuilder()
            .plusMinus()
            .integer()
            .degreeOption()
            .decimalNumber()
            .minuteOption()
            .comma()
            .plusMinus()
            .integer()
            .degreeOption()
            .decimalNumber()
            .minuteOption()
            .build(),
        parser: fromDecimalMinutes,
    },
    {
        regex: new RegexBuilder()
            .integer()
            .degreeOption()
            .decimalNumber()
            .minuteOption()
            .whiteSpace()
            .ns()
            .comma()
            .integer()
            .degreeOption()
            .decimalNumber()
            .minuteOption()
            .whiteSpace()
            .ew()
            .build(),
        parser: fromDecimalMinutesNSEW,
    },
    {
        regex: new RegexBuilder()
            .integer()
            .degreeOption()
            .integer()
            .minuteOption()
            .decimalNumber()
            .secondOption()
            .whiteSpace()
            .ns()
            .whiteSpace()
            .integer()
            .degreeOption()
            .integer()
            .minuteOption()
            .decimalNumber()
            .secondOption()
            .whiteSpace()
            .ew()
            .build(),
        parser: fromMinutesSeconds,
    },
    {
        regex: new RegexBuilder()
            .integer(2)
            .with('[C-X]')
            .whiteSpace()
            .decimalNumber()
            .whiteSpace()
            .decimalNumber()
            .build(),
        parser: fromUtm,
    },
];
export default (input) => {
    const { parser } = parsers.find(({ regex }) => input.match(regex)) || { parser: () => undefined };
    return parser(input);
};
function fromDecimalDegrees(input) {
    const coordinates = input.replace(',', ' ').replace(/\s+/g, ' ').split(' ');
    return {
        lat: parseFloat(coordinates[0]),
        lng: parseFloat(coordinates[1]),
    };
}
function fromDecimalDegreesNSEW(input) {
    const coordinates = input
        .replace(',', ' ')
        .replace(/°/g, ' ')
        .replace(/\s+(\D)/g, '$1')
        .split(' ');
    const lat = coordinates[0].trim().match(/^(\d+(\.\d+)?)([NS])/);
    const lng = coordinates[1].trim().match(/^(\d+(\.\d+)?)([EW])/);
    if (!lat || !lng) {
        return null;
    }
    const getSign = function (direction) {
        return direction === 'N' || direction === 'E' ? 1 : -1;
    };
    return {
        lat: getSign(lat[3]) * parseFloat(lat[1]),
        lng: getSign(lng[3]) * parseFloat(lng[1]),
    };
}
function fromDecimalMinutes(input) {
    const coordinates = input.replace(',', ' ').replace(/°/g, ' ').replace(/\s+/g, ' ').split(' ');
    const lat = [coordinates[0], coordinates[1]];
    const lng = [coordinates[2], coordinates[3]];
    function getSign(input) {
        return parseFloat(input) > 0 ? 1 : -1;
    }
    return {
        lat: parseFloat(lat[0]) + (getSign(lat[0]) * parseFloat(lat[1])) / 60,
        lng: parseFloat(lng[0]) + (getSign(lng[0]) * parseFloat(lng[1])) / 60,
    };
}
function fromDecimalMinutesNSEW(input) {
    const coordinates = input
        .replace(',', ' ')
        .replace(/\s(\D)/g, '$1')
        .split(' ');
    const lat = coordinates[0].trim().match(/^(\d+)°(\d+(\.\d+)?)'([NS])/);
    const lng = coordinates[1].trim().match(/^(\d+)°(\d+(\.\d+)?)'([EW])/);
    if (!lat || !lng) {
        return null;
    }
    const getSign = function (direction) {
        return direction === 'N' || direction === 'E' ? 1 : -1;
    };
    return {
        lat: getSign(lat[4]) * (parseFloat(lat[1]) + parseFloat(lat[2]) / 60),
        lng: getSign(lng[4]) * (parseFloat(lng[1]) + parseFloat(lng[2]) / 60),
    };
}
function fromMinutesSeconds(input) {
    const coordinates = input.replace(/\s(\D)/g, '$1').split(' ');
    const lat = coordinates[0].trim().match(/^(\d+)°(\d+)'(\d+(\.\d+))?"([NS])/);
    const lng = coordinates[1].trim().match(/^(\d+)°(\d+)'(\d+(\.\d+))?"([EW])/);
    if (!lat || !lng) {
        return null;
    }
    const toDecimal = function (minutes, seconds) {
        const number = (parseFloat(minutes) * 60 + parseFloat(seconds)) / 3600;
        return +number.toFixed(5);
    };
    const getSign = function (direction) {
        return direction === 'N' || direction === 'E' ? 1 : -1;
    };
    return {
        lat: getSign(lat[5]) * (parseFloat(lat[1]) + toDecimal(lat[2], lat[3])),
        lng: getSign(lng[5]) * (parseFloat(lng[1]) + toDecimal(lng[2], lng[3])),
    };
}
function fromUtm(input) {
    const match = input.match(/^(\d{2})([C-X]) (\d+(\.\d+)?) (\d+(\.\d+)?)$/);
    if (!match) {
        return null;
    }
    const easting = parseFloat(match[3]);
    const northing = parseFloat(match[5]);
    const zoneNumber = parseInt(match[1]);
    const zoneLetter = match[2];
    const coordinates = toLatLon(easting, northing, zoneNumber, zoneLetter);
    return {
        lat: +coordinates.latitude.toFixed(5),
        lng: +coordinates.longitude.toFixed(5),
    };
}
//# sourceMappingURL=parse-coords.js.map